// Library imports
import { useEffect, useRef, useState } from "react";

// 「コピーしました」を出しておく時間(ms)
const COPIED_LABEL_DURATION = 2000;

/**
 * URL をクリップボードへコピーし、どれをコピーしたか（key）をしばらく覚えておく
 */
export const useCopyUrl = (onError) => {
    const [copiedKey, setCopiedKey] = useState(null);
    const timer = useRef(null);

    useEffect(() => () => {
        if (timer.current) clearTimeout(timer.current);
    }, []);

    const copyUrl = (key, url) => {
        // クリップボードAPIは https（または localhost）でしか使えない
        if (!navigator.clipboard) {
            onError();
            return;
        }
        navigator.clipboard.writeText(url)
            .then(() => {
                if (timer.current) clearTimeout(timer.current);
                setCopiedKey(key);
                timer.current = setTimeout(() => {
                    timer.current = null;
                    setCopiedKey(null);
                }, COPIED_LABEL_DURATION);
            })
            .catch(onError);
    };

    return { copiedKey, copyUrl };
};
